'use client';

import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { cookies } from '@/lib/jucyCookies';
import { CmsPage } from '@/services/cms/pages/CmsPage';

export interface TradeDoublerProps {
    pageData?: CmsPage;
    pageSlug?: string[];
}

export const TradeDoubler = (props: TradeDoublerProps) => {
    const query = useSearchParams();
    if (query?.get('tduid')) {
        cookies.set('TRADEDOUBLER', query.get('tduid'));
    }

    const pageData = props.pageData;
    if (pageData?.className === 'FleetCategoryPage') {
        return (
            <Script
                id="tradedoubler-product-page-loader"
                src="https://swrap.tradedoubler.com/wrap?id=28075"
                strategy="afterInteractive"
                onReady={() => {
                    window.TDConf = window.TDConf || {};
                    window.TDConf.config = {
                        productId: pageData.fleetCategory?.code,
                        category: pageData.fleetCategory?.fleetType,
                        brand: 'JUCY',
                        productName: pageData.fleetCategory?.name,
                        productDescription: pageData.fleetCategory?.shortDescription,
                        url: window.location.href,
                        ...(pageData.fleetCategory?.scenicImage
                            ? {
                                  imageUrl: pageData.fleetCategory?.scenicImage,
                              }
                            : undefined),
                    };
                }}
            />
        );
    }
    if (!props.pageSlug) {
        return (
            <Script
                id="tradedoubler-home-page-loader"
                src="https://swrap.tradedoubler.com/wrap?id=28073"
                strategy="afterInteractive"
                onReady={() => {
                    window.TDConversionObject = 'tdconv';

                    const tdconv = () => {
                        (window.tdconv.q = window.tdconv.q || []).push({
                            0: window,
                            1: document,
                            2: 'script',
                            3: 'https://svht.tradedoubler.com/tr_sdk.js',
                            4: 'tdconv',
                        });
                    };
                    window.tdconv = window.tdconv || tdconv;
                    window.tdconv.l = new Date().getTime();
                    const a = document.createElement('script');
                    const m = document.getElementsByTagName('script')[0];
                    a.async = true;
                    a.src = 'https://svht.tradedoubler.com/tr_sdk.js';
                    m?.parentNode?.insertBefore(a, m);
                }}
            />
        );
    }
};

type TDConversion = {
    (action: string, arg: string, data: unknown): void;
    q?: unknown[];
    l?: number;
};
declare global {
    interface Window {
        TDConversionObject: string;
        tdconv: TDConversion;
        TDConf: Record<string, unknown>;
    }
}
